import type { QualityStatus } from "./types";

export function coverageQualityStatus(
  sourceQuality: "ok" | "partial" | "low-quality" | "unavailable",
): QualityStatus {
  return sourceQuality === "ok" ? "good" : sourceQuality;
}

const qualitySeverity: Readonly<Record<QualityStatus, number>> = {
  good: 0,
  partial: 1,
  "low-quality": 2,
  unavailable: 3,
};

export function worstQualityStatus(
  first: QualityStatus,
  second: QualityStatus,
): QualityStatus {
  return qualitySeverity[first] >= qualitySeverity[second] ? first : second;
}
